import { render, staticRenderFns } from "./ConfirmImageSendModal.vue?vue&type=template&id=ea6da5c2&scoped=true&"
import script from "./ConfirmImageSendModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmImageSendModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmImageSendModal.vue?vue&type=style&index=0&id=ea6da5c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea6da5c2",
  null
  
)

export default component.exports